let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("fliVL"), load("lFSUi")]).then(() => parcelRequire('fr6n2'));